import { render, staticRenderFns } from "./Speakers.vue?vue&type=template&id=0ed7f8ea&scoped=true&"
import script from "./Speakers.vue?vue&type=script&lang=js&"
export * from "./Speakers.vue?vue&type=script&lang=js&"
import style0 from "./Speakers.vue?vue&type=style&index=0&id=0ed7f8ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed7f8ea",
  null
  
)

component.options.__file = "Speakers.vue"
export default component.exports